import React from 'react';
import { m } from 'framer-motion';
import { PrimaryButton } from '../ui/PrimaryButton';
export function FinalCTA() {
  return <section className="bg-navy py-12 sm:py-16" data-id="element-49" data-mp="5cqxme3kzz97">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-50" data-mp="3mu1r42g0wwaq">
        <h2 className="font-heading text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-51" data-mp="3mrnye08tfw6c">
          No esperes al próximo semestre.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-52" data-mp="3ds0u96opcc9l">
          Mañana ya puedes usar la primera clase lista.
        </p>
        <p className="mt-2 font-semibold text-orange" data-id="element-53" data-mp="3hscfolow2gm4">19€. Acceso de por vida. Garantía 7 días.</p>

        <m.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mt-8 flex justify-center" data-id="element-54" data-mp="33x8zeami83ii">
          <PrimaryButton size="lg" data-id="element-55" data-mp="172w0xxlat0e3">Acceso Ahora — 19€</PrimaryButton>
        </m.div>

        <p className="mt-4 text-xs text-white/60" data-id="element-56" data-mp="q8deqrs1cmpl">Dinero de vuelta si no funciona. Sin preguntas.</p>
      </div>
    </section>;
}